<template>
  <div v-if="items.length > 0" class="border-b border-gray-100 dark:border-gray-700/50">
    <div
      class="sticky top-0 flex items-center justify-between border-b border-gray-200/50 bg-gradient-to-r from-gray-50 to-white px-3 py-2.5 text-xs font-bold tracking-wider text-gray-600 uppercase backdrop-blur-sm sm:px-4 dark:border-gray-700/50 dark:from-gray-900 dark:to-gray-800 dark:text-gray-300"
    >
      <div class="flex items-center gap-2">
        <div class="flex h-5 w-5 items-center justify-center rounded-md" :class="SEARCH_PALETTE[color].badge">
          <i :class="`pi pi-${icon} text-xs ${SEARCH_PALETTE[color].icon}`"></i>
        </div>
        <span>{{ title }}</span>
      </div>
      <span
        class="rounded-full px-2 py-0.5 text-[10px] font-semibold"
        :class="[SEARCH_PALETTE[color].badge, SEARCH_PALETTE[color].count]"
      >
        {{ items.length }}
      </span>
    </div>

    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { SEARCH_PALETTE, type SearchColor } from './searchColors';

defineProps<{
  items: unknown[];
  title: string;
  icon: string;
  color: SearchColor;
}>();
</script>
